import { render } from "./WCEmployeeActionsCollapsibleMenu.vue?vue&type=template&id=68a3823a&scoped=true"
import script from "./WCEmployeeActionsCollapsibleMenu.vue?vue&type=script&lang=js"
export * from "./WCEmployeeActionsCollapsibleMenu.vue?vue&type=script&lang=js"

import "./WCEmployeeActionsCollapsibleMenu.vue?vue&type=style&index=0&id=68a3823a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a3823a"]])

export default __exports__